import { useState, useEffect } from 'react';
import useAuth from '../../../../hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentUserProfile, setUserProfile, logout } from '../../../../store/slices/authSlice';
import api from '../../../../api/axios';
import { useLoading } from '../../../../components/LoadingProvider';
import { showError } from '../../../../utils/toast';
import DoctorProfileSideBar from './sidebar';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export default function DoctorProfile() {
    const currentProfileData = useSelector(selectCurrentUserProfile);
    const [profileData, setProfileData] = useState(currentProfileData);
    const dispatch = useDispatch();
    const { user, isAuthenticated, userRole } = useAuth({ redirectPath: '/login', allowedRoles: ['doctor'] });
    const navigate = useNavigate();
    const { setIsLoading } = useLoading();
    const MySwal = withReactContent(Swal);

    const fetchDoctorData = async () => {
        try {
            setIsLoading(true);
            const response = await api.get('/doctor/details');
            if (response?.data?.result === 'success') {
                let data = {
                    name: response.data.data.formated_name || '',
                    dob: response.data.data.formated_dob || '',
                    gender: response.data.data.formated_gender || '',
                    address: {
                        line1: response.data.data.address_line1 || '',
                        line2: response.data.data.address_line2 || '',
                        district: response.data.data.district || '',
                        state: response.data.data.state || '',
                        country: response.data.data.country || '',
                        pincode: response.data.data.pincode || '',
                    },
                    email: response.data.data.email || '',
                    phoneCode: response.data.data.phone_code || '',
                    phoneNumber: response.data.data.phone_number || '',
                    bio: response.data.data.bio || '',
                    profile_picture: response.data.data.profile_picture || '',
                    years_of_experience: response.data.data.years_of_experience || '',
                    contactNumber: '',
                    specializations_name: response.data.data.specializations_name || '',
                    education_background: response.data.data.education_background || '',
                    symptoms: response.data.data.symptoms || '',
                };
                setProfileData(data);
            }else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError('Something went wrong! Please try again later.');
            if (error.response?.status === 401) {
                navigate('/login');
            }
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        document.title = 'Varosa - Doctor Profile';
        fetchDoctorData();
    }, []);

    const deleteAccountPopup = () => {
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You want to delete your account?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
        }).then((result) => {
            if (result.isConfirmed) {
                deleteAccount();
            }
        });
    };
    const deleteAccount = async () => {
        try {
            setIsLoading(true);
            const response = await api.post('/doctor/profile/delete');
            if (response?.data?.result === 'success') {
                showError('Account deleted successfully!');
                dispatch(logout());
                navigate('/login');
            }else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError('Something went wrong! Please try again later.');
            if (error.response?.status === 401) {
                navigate('/login');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="container-fluid contact py-5">
                <div className="container py-5">
                    <div className="row g-4">
                        <div className="col-lg-4 col-xl-4 contact-form wow fadeInLeft" data-wow-delay="0.1s">
                            <DoctorProfileSideBar user={user} role={userRole} profileData={profileData} />
                        </div>
                        <div className="col-lg-8 col-xl-8 contact-form wow fadeInLeft" data-wow-delay="0.1s">
                            <div className="card">
                                <h5 className="card-header p-3">
                                    My Profile Information
                                </h5>
                                <div className="card-body p-3">
                                    <p className="card-text">
                                        <b>Name:</b> {profileData?.name}
                                        <br /><br />
                                        <b>Phone:</b> {profileData?.phoneCode} {profileData?.phoneNumber}
                                        <br /><br />
                                        <b>My Bio:</b> {profileData?.bio}
                                        <br /><br />
                                        <b>Specialization:</b> {profileData?.specializations_name?.length > 0 ? profileData?.specializations_name.join(', ') : profileData?.specialization}
                                        <br /><br />
                                        <b>Years of Experience:</b> {profileData?.years_of_experience} Years
                                        <br /><br />
                                        <b>Education Background:</b> {profileData?.education_background}
                                        <br /><br />
                                        {profileData?.symptoms && <>
                                            <b>Symptoms Treated:</b> {profileData?.symptoms}
                                            <br /><br />
                                        </>}
                                        <b>Email:</b> {profileData?.email}
                                        {/* <br /><br />
                                        <b>Date of Birth:</b> {profileData?.dob}
                                        <br /><br />
                                        <b>Gender:</b> {profileData?.gender} */}
                                        <br /><br />
                                        <b>Address:</b> {profileData?.address?.line1}, {profileData?.address?.line2}, {profileData?.address?.district}, {profileData?.address?.state}, {profileData?.address?.country}, {profileData?.address?.pincode}
                                        <br />
                                    </p>
                                </div>
                                <div className="card-footer text-muted p-3">
                                    <Link to="/dashboard/doctor/profile/edit" className="btn btn-primary float-start">Edit Profile</Link>
                                    <button onClick={deleteAccountPopup} className="btn btn-danger ms-2 float-end">Delete Account</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}